import  Vue, {  }  from 'vue';

export function useIp() {
  //const instance = getCurrentInstance();

  //const proxy = instance?.proxy

  return {
    ipUser: Vue.prototype.$ipUser,
    ipSecurity: Vue.prototype.$ipSecurity,
    ipMasterData: Vue.prototype.$ipMasterData,
    ipProposal: Vue.prototype.$ipProposal,
    ipPurchase: Vue.prototype.$ipPurchase,
    ipApprovalFlow: Vue.prototype.$ipApprovalFlow,
    ipIntegrationOmie: Vue.prototype.$ipIntegrationOmie,
    ipStock: Vue.prototype.$ipStock,
    ipWebSocket: Vue.prototype.$ipWebSocket,
  }
}
